import { SVG } from "./mimeTypes.js";

export const vectorTypes = [SVG];
